import { render, staticRenderFns } from "./SeatPlan.vue?vue&type=template&id=7e88b846"
import script from "./SeatPlan.vue?vue&type=script&lang=js"
export * from "./SeatPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports